"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiInputBase = void 0;
exports.MuiInputBase = {
    styleOverrides: {
        root: {
            height: "var(--input-height)",
            backgroundColor: "#fff",
            "input[disabled]": {
                cursor: "not-allowed",
            },
            "input::placeholder": {
                color: "var(--input-disabled-text-color)",
                WebkitTextFillColor: "var(--input-disabled-text-color)",
            },
            "&.Mui-disabled": {
                backgroundColor: "var(--input-disabled-background-color)",
            },
            "&.MuiOutlinedInput-root": {
                borderRadius: "var(--input-border-radius)",
            },
        },
    },
};
//# sourceMappingURL=MuiInputBase.js.map